module.exports = __webpack_public_path__ + "img/category_5.4d9438f5.svg";